import { isBrowser } from '../constants';
import { publicApi } from './index';

export const getAudByUuid = async (uuid: string) => {
  return publicApi.get(
    `/audience/${uuid}`,
    isBrowser && localStorage.getItem('token')
      ? {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      : {}
  );
};
